import { SalsaBadge } from './SalsaBadge.js'
import { SalsaImagePlaceholder } from './SalsaImagePlaceholder.js'

export const SalsaCard = (props) => (
    <div
        className="border grid items-stretch overflow-hidden rounded-md shadow content-between"
        id={props.id}
        ref={props.ref}
    >
        <div>
            <a href={props.href} className="block">
                {
                    props.image.src
                        ? <img src={props.image.src} alt={props.image.alt} className="object-contain w-full" />
                        : <SalsaImagePlaceholder className="object-cover w-full bg-navy" />
                }

            </a>
            <div className="grid content-start p-4 pb-0 gap-3">
                <div className="grid grid-cols-1fr-maxcontent max-w-full overflow-hidden">

                    <a href={props.href}><h3 className="font-semibold text-blue text-xl">{props.title}</h3></a>
                </div>
                <div>
                    {
                        props.eventDetails
                            ? (
                                <ul className="list-none m-0 p-0 grid gap-2">
                                    <li className="ml-0">
                                        <strong>Category:</strong> {props.eventDetails.category}</li>
                                    <li className="ml-0">
                                        <strong>When:</strong> {props.eventDetails.date}</li>
                                    <li className="ml-0">
                                        <strong>Where:</strong> {props.eventDetails.location}</li>
                                </ul>
                            )
                            : null
                    }
                </div>
                <div>
                    <p>{props.body}</p>
                </div>
            </div>
        </div>
        <div className="grid gap-2 p-4 pt-0 self-end"> <a href={props.href}
            className="text-blue text-base inline-grid gap-2 grid-col-2-maxcontent items-center"><span>Learn
                more</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" id="forward"
                    className="fill-current w-3.5 h-3.5">
                <path
                    d="M3.4 29h33.2c.9 0 1.3 1.1.7 1.7l-9.6 9.6c-.6.6-.6 1.5 0 2.1l2.2 2.2c.6.6 1.5.6 2.1 0L49.5 27c.6-.6.6-1.5 0-2.1L32 7.4c-.6-.6-1.5-.6-2.1 0l-2.1 2.1c-.6.6-.6 1.5 0 2.1l9.6 9.6c.6.7.2 1.8-.7 1.8H3.5c-.8 0-1.5.6-1.5 1.4v3c0 .8.6 1.6 1.4 1.6z">
                </path>
            </svg>
        </a>

            {/* <a href={`${props.href}#register`} className="text-blue text-base inline-grid gap-2 grid-col-2-maxcontent items-center">
                <span>Register</span>
            </a> */}
        </div>
    </div>
)

export default SalsaCard